import template from './NotificationsView.hbs';
import {AggregatedUserNotificationCollection} from '../../../collection/notifications/AggregatedUserNotificationCollection';
import {router} from '../../../../js/router';
import {BaseView, Prototype} from '../../BaseView';

/**
 * @class NotificationsView
 * @extends BaseView
  */
@Prototype({
    template,
    className: 'notifications',
    ui: {
        toggle: '.notifications-toggle button',
        panel: '.notifications__panel',
    },
    events: {
        'click @ui.toggle': 'togglePanel',
    },
    collectionEvents: {
        'sync reset': 'render',
    },
})
export class NotificationsView extends BaseView {

    initialize () {
        let userUuid = this.options.userUuid;
        let language = router.getLastEventLanguage2Char();
        let country = router.getLastEventCountryCode();

        if (!userUuid || !language || !country) {
            return;
        }

        let parent = this.options.parent;
        if (!parent.notifications) {
            parent.notifications = AggregatedUserNotificationCollection.factory({
                userUuid,
                language,
                country
            });
        }

        this.collection = parent.notifications;

        if (!parent.notificationsPromise) {
            parent.notificationsPromise = this.collection.update();
        }

        this.isLoading = true;
        parent.notificationsOpen = false;

        parent.notificationsPromise.then(() => {
            if (this.isDestroyed()) {
                return;
            }
            this.isLoading = false;
            this.buildGroups();
            this.safeRender();
        })
    }

    serializeData () {
        return {
            groups: this.groups,
            collection: this.collection,
            isLoading: this.isLoading,
            isOpen: this.options.parent.notificationsOpen,
        };
    }

    /**
     * Group notification by date
     */
    buildGroups () {
        this.groups = this.collection.groupBy((model) => model.getDateString());
        this.groups = _.map(this.groups, (arr, date) => ({
            date: arr[0].getDate(),
            dateString: date,
            collection: new AggregatedUserNotificationCollection(arr),
        }));
        this.groups = _.sortBy(this.groups, (g) => -g.date.unix());
    }

    togglePanel () {
        this.options.parent.notificationsOpen = !this.options.parent.notificationsOpen;
        this.ui.panel.toggleClass('hidden', !this.options.parent.notificationsOpen);
    }
}


// WEBPACK FOOTER //
// ./shared/view/NavigationBarView/Notifications/NotificationsView.js